import React from "react";
import { Stack } from "@mui/material";

type ContainerProps = {
  conLinea?: boolean;
  children: React.ReactNode;
};

export default function Container({ children }: ContainerProps) {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        justifyContent: "center",
        minHeight: "670px",
      }}
    >
      <Stack
        sx={{
          alignItems: "center",
          width: "100%",
          maxWidth: 800,
          margin: 3,
          bgcolor: "#FFDDE4",
          borderRadius: 2,
          boxShadow: "3px 3px 12px 1px rgba(112, 112, 112, 0.56)",
          paddingBottom: 2,
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
}
